/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Notes_Delete_Note_ConfirmInputs */

const en_mobile_notes_delete_note_confirm = /** @type {(inputs: Mobile_Notes_Delete_Note_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this note?`)
};

const es_mobile_notes_delete_note_confirm = /** @type {(inputs: Mobile_Notes_Delete_Note_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Estás seguro de que quieres eliminar esta nota?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete this note?" |
*
* @param {Mobile_Notes_Delete_Note_ConfirmInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_notes_delete_note_confirm = /** @type {((inputs?: Mobile_Notes_Delete_Note_ConfirmInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Notes_Delete_Note_ConfirmInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_notes_delete_note_confirm(inputs)
	return en_mobile_notes_delete_note_confirm(inputs)
});